import { render, staticRenderFns } from "./createWHProduct.vue?vue&type=template&id=8e3e9080&"
import script from "./createWHProduct.vue?vue&type=script&lang=js&"
export * from "./createWHProduct.vue?vue&type=script&lang=js&"
import style0 from "./createWHProduct.vue?vue&type=style&index=0&id=8e3e9080&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports